import React, { useEffect, useRef, useState } from 'react';

/** Значение, которое обновляется после паузы в `delayMs` (поиск не стучится на каждую букву); пустая строка применяется сразу. */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    if ((value as unknown) === '') {
      // пустое поле действует сразу: прежнее слово не должно уходить в запрос, пока набирают новое
      setDebounced(value);
      return undefined;
    }
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}

/**
 * Ссылка для элемента, который должен получить фокус, когда появляется (`active` стало true).
 * Когда подтверждение заменяет экран или открывается посреди списка, нажатая кнопка исчезает и фокус клавиатуры
 * и чтеца экрана падает на страницу; заголовок подтверждения (с `tabIndex={-1}`) принимает его вместо неё.
 */
export function useFocusOnShow<T extends HTMLElement>(active = true): React.RefObject<T> {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (active) ref.current?.focus();
  }, [active]);
  return ref;
}
